<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <navbar>
      <template v-slot:navbarname>
        <b-link
            :to="{name:'ProductsList',params:{'categoryid':form.category}}"
            class="btn btn-primary btn-round">
          back
        </b-link>
      </template>
    </navbar>

    <h2 v-html="form.title"></h2>


    <b-card no-body>
      <b-tabs pills card vertical>
        <b-tab active v-if="role === 'admin'" title="Image">
          <b-row>
            <b-col cols="12" md="6">
              <b-form-group
                  class="required"
                  :state="!validation.hasError('image')"
                  :invalid-feedback="validation.errorTitle('image')"
                  label="thumb image">
                <template v-if="previewUrl !== null">
                  <b-img :src="previewUrl" width="150"></b-img>
                </template>
                <b-form-file @change="onSelectFile" v-model="formImage.image"></b-form-file>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group
                  class="required"
                  :state="!validation.hasError('image_cover')"
                  :invalid-feedback="validation.errorTitle('image_cover')"
                  label="cover image">
                <template v-if="previewCoverUrl !== null">
                  <b-img :src="previewCoverUrl" width="150"></b-img>
                </template>
                <b-form-file @change="onSelectFileCover" v-model="formImage.image_cover"></b-form-file>
              </b-form-group>
            </b-col>
          </b-row>

          <b-button variant="success" @click="updateImage">{{ $t('saveTitle') }}</b-button>

        </b-tab>
        <!--END Image-->
        <b-tab v-if="role === 'admin'" title="Gallery">
          <b-form-group label="Bilder">
            <b-form-file id="images" @change="onSelectFiles" multiple></b-form-file>
          </b-form-group>

          <template v-if="formImage.images.length">
            <b-row>
              <b-col
                  v-for="(image,index) in imagesPreview"
                  :key="index"
                  cols="12" md="3">
                <b-card>
                  <b-img :src="image.url" height="85"></b-img>
                  <p>
                    <b-link class="text-danger" @click.prevent="removeImage(image)">
                      delete
                    </b-link>
                  </p>
                </b-card>
              </b-col>
            </b-row>
          </template>

          <br>
          <br>
          <br>
          <h3>Saved</h3>
          <template v-if="imagesFromServer.length">
            <b-row>
              <b-col
                  v-for="(image,index) in imagesFromServer"
                  :key="index"
                  cols="12" md="3">
                <b-card>
                  <b-img :src="image.image_url" height="85"></b-img>
                  <p>
                    <b-link class="text-danger" @click.prevent="deleteImage(image.image_id)">
                      delete
                    </b-link>
                  </p>
                </b-card>
              </b-col>
            </b-row>
          </template>


          <b-button v-if="imagesPreview.length > 0" variant="success" @click="updateGalleryImage">
            {{ $t('saveTitle') }}
          </b-button>

        </b-tab>
        <!--END Gallery-->
        <b-tab @click="getDetailsProduct($route.params.productid)" title="Information">
          <template v-if="isReceiveData">
            <b-form-group label="select category">
              <b-form-select
                  v-model="form.category"
                  :options="categories"
                  class="mb-3"
                  value-field="id"
                  text-field="title"
              ></b-form-select>

            </b-form-group>
            <b-form-group label="select sub category">
              <b-form-select
                  v-model="form.subCategory"
                  :options="categoryItem.subCategories"
                  class="mb-3"
                  value-field="id"
                  text-field="title"
              ></b-form-select>
              <a href="#"
                 @click.prevent="form.subCategory=null"
                 class="text-danger font-weight-bold">remove sub category</a>
            </b-form-group>
            <b-form-group
                v-if="role === 'admin'"
                class="required"
                label="Titel"
                :state="!validation.hasError('title')"
                :invalid-feedback="validation.errorTitle('title')"
            >
              <b-input v-model="form.title"></b-input>
            </b-form-group>
            <b-form-group
                class="required"
                label="seo url"
                :state="!validation.hasError('title_seo')"
                :invalid-feedback="validation.errorTitle('title_seo')"
            >
              <b-input placeholder="lordofhanf.com/product/" v-model="form.title_seo"></b-input>
            </b-form-group>
            <b-form-group
                v-if="role === 'admin'"
                label="Preisschild"
                :state="!validation.hasError('price_label')"
                :invalid-feedback="validation.errorTitle('price_label')"
            >
              <b-input v-model="form.price_label"></b-input>
            </b-form-group>
            <b-form-group
                label="CBD"
                v-if="role === 'admin'"
                :state="!validation.hasError('cbd')"
                :invalid-feedback="validation.errorTitle('cbd')"
            >
              <b-input v-model="form.cbd"></b-input>
            </b-form-group>
            <b-form-group
                label="CBG"
                v-if="role === 'admin'"
                :state="!validation.hasError('cbg')"
                :invalid-feedback="validation.errorTitle('cbg')"
            >
              <b-input v-model="form.cbg"></b-input>
            </b-form-group>
            <b-form-group
                label="THC"
                v-if="role === 'admin'"
                :state="!validation.hasError('thc')"
                :invalid-feedback="validation.errorTitle('thc')"
            >
              <b-input v-model="form.thc"></b-input>
            </b-form-group>

            <b-button variant="success" @click="updateInformation">{{ $t('saveTitle') }}</b-button>
          </template>

        </b-tab>
        <!--END Information-->
        <b-tab title="Description">
          <b-form-group
              class="required"
              label="Beschreibung"
              :state="!validation.hasError('description')"
              :invalid-feedback="validation.errorTitle('description')"
          >
            <tinymce id="d1" :other_options="optionsEditor" v-model="form.description"></tinymce>
          </b-form-group>
          <b-form-group
              label="Paketbeschreibung"
              :state="!validation.hasError('description_package')"
              :invalid-feedback="validation.errorTitle('description_package')"
          >
            <tinymce id="d2" :other_options="optionsEditor" v-model="form.description_package"></tinymce>
          </b-form-group>
          <b-form-group
              label="Out of stock message"
          >
            <tinymce id="d4" :other_options="optionsEditor" v-model="form.product_out_stock_message"></tinymce>
          </b-form-group>

          <b-button variant="success" @click="updateInformation">{{ $t('saveTitle') }}</b-button>

        </b-tab>
        <!--END Description-->
        <b-tab title="Google SEO">
          <b-form-group label="Product Number">
            <b-input v-model="form.product_number"></b-input>
          </b-form-group>
          <b-form-group label="Brand">
            <b-input v-model="form.brand"></b-input>
          </b-form-group>
          <b-form-group label="Meta Title">
            <b-input v-model="form.meta_title"></b-input>
          </b-form-group>
          <b-form-group label="Beschreibung Seo">
            <tinymce id="d3" :other_options="optionsEditor" v-model="form.seocontent"></tinymce>
          </b-form-group>

          <b-button variant="success" @click="updateInformation">{{ $t('saveTitle') }}</b-button>

        </b-tab>
        <!--END Google SEO-->
        <b-tab @click="getDetailsProduct($route.params.productid)" v-if="role === 'admin'" title="Options">

          <template v-if="isReceiveData">
            <b-row>
              <b-col cols="12" md="6">
                <b-form-checkbox v-model="form.is_biologisch">is preisschild ?</b-form-checkbox>
                <b-form-checkbox v-model="form.is_new">is neu ?</b-form-checkbox>
                <b-form-checkbox v-model="form.is_hidden">is hide ?</b-form-checkbox>
                <b-form-checkbox v-model="form.is_comingsoon">is Bald im Sortiment ?
                </b-form-checkbox>

                <div class="custom-control custom-radio">
                  <input type="radio"
                         :checked="packageStatus === 'package'"
                         @change="onChangePackageType('package')"
                         id="customRadio1" name="package" class="custom-control-input">
                  <label class="custom-control-label" for="customRadio1">produkt is selectable packet
                    ?</label>
                </div>
                <div class="custom-control custom-radio">
                  <input type="radio"
                         :checked="packageStatus === 'packageAndHide'"
                         @change="onChangePackageType('packageItems')"
                         id="customRadio2" name="package" class="custom-control-input">
                  <label class="custom-control-label" for="customRadio2">
                    is packet & saved items default (without select)
                  </label>
                </div>

                <b-form-checkbox v-model="form.is_top_seller">is beseller ?
                </b-form-checkbox>


                <template v-if="form.is_package || form.is_hide_package_items">
                  <b-link class="text-danger" @click="removePackageFilter">remove package</b-link>
                </template>

                <b-form-checkbox v-model="form.is_custom_badge">is custom badge ?</b-form-checkbox>
                <b-form-checkbox v-model="form.is_advertising">Advertising (Adcell) ?</b-form-checkbox>


                <template v-if="form.is_custom_badge">
                  <b-form-group
                      label="badge title"
                  >
                    <b-input v-model="form.custom_badge_title"></b-input>
                  </b-form-group>

                  <b-form-group
                      label="badge text"
                  >
                    <b-input v-model="form.custom_badge_text"></b-input>
                  </b-form-group>
                </template>

              </b-col>

              <b-col cols="12" md="6">
                <b-form-group
                    class="required"
                    label="Inventurzählung"
                    :state="!validation.hasError('inventory_count')"
                    :invalid-feedback="validation.errorTitle('inventory_count')"
                >
                  <b-input type="number" v-model.number="form.inventory_count"></b-input>
                </b-form-group>
                <b-form-group
                    class="required"
                    label="Tax">
                  <b-form-select v-model="form.tax">
                    <b-form-select-option value="10">10%</b-form-select-option>
                    <b-form-select-option value="13">13%</b-form-select-option>
                    <b-form-select-option value="20">20%</b-form-select-option>
                  </b-form-select>
                </b-form-group>

                <b-form-group
                    label="Rabatt Prozent"
                    :state="!validation.hasError('is_offer')"
                    :invalid-feedback="validation.errorTitle('is_offer')"
                >
                  <b-form-select
                      @change="onSelectOfferType"
                      v-model="form.is_offer" class="mb-3">
                    <b-form-select-option value="no">No discount</b-form-select-option>
                    <b-form-select-option value="yes">yes</b-form-select-option>
                    <b-form-select-option value="init">Discount within the calculated product
                    </b-form-select-option>
                  </b-form-select>

                  <b-input class="required" type="number" placeholder="ex : 10"
                           v-model.number="form.offer_inp"
                           v-if="form.is_offer === 'yes'"
                  ></b-input>

                </b-form-group>

                <b-form-group label="Preise sortieren">
                  <b-form-select v-model="form.is_order_type">
                    <b-form-select-option value="titleAZ">Price Title A - Z</b-form-select-option>
                    <b-form-select-option value="titleZA">Price Title Z - A</b-form-select-option>
                    <b-form-select-option value="priceHighToLow">Price high to low
                    </b-form-select-option>
                    <b-form-select-option value="priceLowToHigh">Price low to high
                    </b-form-select-option>
                  </b-form-select>
                </b-form-group>

                <template v-if="form.is_package || form.is_hide_package_items">
                  <b-form-group label="select package count">
                    <b-input type="number" v-model.number="form.select_package_count"></b-input>
                  </b-form-group>
                </template>

                <b-form-group label="Show Prise Group">
                  <b-form-select
                      v-model="form.is_show_price_group"
                      class="mb-3">
                    <b-form-select-option value="no">No</b-form-select-option>
                    <b-form-select-option value="yes">Yes</b-form-select-option>
                  </b-form-select>
                </b-form-group>

                <b-form-group
                    v-if="form.is_show_price_group === 'yes'"
                    label="Which price group do you want to display?">
                  <b-form-select
                      v-model="form.price_group_id"
                      :options="priceGroup.items"
                      class="mb-3"
                      value-field="id"
                      text-field="title"
                  ></b-form-select>
                </b-form-group>


              </b-col>
            </b-row>

            <b-button variant="success" @click="updateInformation">{{ $t('saveTitle') }}</b-button>
          </template>

        </b-tab>
        <!--END Options-->
        <b-tab v-if="role === 'admin'" title="Packages">
          <template v-if="form.is_hide_package_items || form.is_package">
            <b-row>
              <b-col cols="12" md="3">
                <b-form-group label="titel">
                  <b-input v-model="packageItem.title"></b-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="3">
                <b-form-group label="select product">
                  <v-select
                      class="bg-white"
                      placeholder="select product"
                      label="product_title"
                      :reduce="product_title => product_title.product_id"
                      v-model="packageItem.product_id"
                      :options="products"></v-select>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="2">
                <b-form-group label="decrement count">
                  <b-input v-model="packageItem.count"></b-input>

                </b-form-group>
              </b-col>
              <b-col cols="12" md="2">
                <b-form-group label="show/hide">
                  <b-form-checkbox v-model="packageItem.isHide">is hide ?</b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="4">
                <b-form-group label="Show for this product?">
                  <b-form-checkbox v-model="packageItem.isCustomTitle">
                    Show for this product?
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="2">

                <template v-if="editPackageItem !== null">
                  <b-button variant="success"
                            @click="updatePackageItemProcess">
                    {{ $t('saveTitle') }}
                  </b-button>
                  <b-button variant="danger" @click="deletePackageItemValues">
                    cancel
                  </b-button>
                </template>
                <template v-else>
                  <b-button v-if="packageStatus ==='packageAndHide'" variant="info"
                            @click="addPackageItem">
                    {{ $t('addTitle') }}
                  </b-button>
                  <b-button v-else-if="packageStatus ==='package'" variant="info"
                            @click="storePackage">
                    {{ $t('addTitle') }}
                  </b-button>
                </template>


              </b-col>
            </b-row>


            <template v-if="packageStatus ==='packageAndHide'">
              <h3>Preview Packages To be Saved</h3>
              <p v-if="packages.length === 0">nothing!</p>
              <packages :packages="packages" :isTab="myFalse" :isServer="myFalse"></packages>
            </template>
            <!--Items-->

            <b-button v-if="form.is_hide_package_items && packages.length > 0" @click="updatePackage"
                      variant="success">{{ $t('saveTitle') }}
            </b-button>

            <br>
            <br>
            <br>
            <br>
          </template>

          <template v-if="packageStatus ==='package'">
            <packages :packages="packages"
                      :packagesCustomTitle="packagesCustomTitle"
                      :packagesCategory="packagesCategory"
                      :isTab="myTrue" :isServer="myTrue"></packages>
          </template>
          <template v-else-if="packageStatus ==='packageAndHide'">
            <h3>Initial Packages Saved</h3>
            <packages :packages="packagesSavedProductServer" :isTab="myFalse" :isServer="myTrue"></packages>
          </template>
          <!--From Server-->


        </b-tab>
        <!--END Packages-->
        <b-tab @click="deletePriceItemValues" v-if="role === 'admin'" title="Prise">
          <b-row>
            <b-col cols="12" md="2">
              <b-form-group label="select prise type">
                <b-form-select @input="onSelectPriceType">
                  <b-form-select-option value="gram">Gram</b-form-select-option>
                  <b-form-select-option value="gram_offer">Gram Discount</b-form-select-option>
                  <b-form-select-option value="single_price">Single Prise</b-form-select-option>
                  <b-form-select-option value="single_price_offer">Single Prise Discount
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="4" v-if="isPriceGram">
              <b-form-group label="Titel">
                <b-input v-model="priceItem.title"></b-input>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="3" v-if="isPriceGram">
              <b-form-group label="Abnehmen aus dem Lager">
                <b-input v-model.number="priceItem.amountgram" type="number"></b-input>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="3"
                   v-if="isPriceOffer">
              <b-form-group label="Rabbat Percent">
                <b-input v-model.number="priceItem.offerDiscount" type="number"></b-input>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="2">
              <b-form-group label="price">
                <b-input v-model.number="priceItem.price" type="number"></b-input>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="2"
                   v-if="priceItem.priceType === 'single_price_offer' || priceItem.priceType === 'gram_offer'">
              <b-form-group label="price sell">
                <b-input v-model.number="priceItem.priceSell" type="number"></b-input>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="3">
              <b-form-group label="Mit Rabatt anzeigen?">
                <b-form-checkbox v-model="priceItem.priceGroup">Mit Rabatt anzeigen?</b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="3">
              <b-form-group label="is Hide?">
                <b-form-checkbox v-model="priceItem.isHide">is Hide?</b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>

          <template v-if="editPriceItem !== null">
            <b-button variant="success" @click="updatePrice">{{ $t('saveTitle') }}</b-button>
            <b-button variant="danger" @click="deletePriceItemValues">{{ $t('cancelTitle') }}</b-button>
          </template>
          <template v-else>
            <b-button variant="info" @click="addPriceItem('default')">{{ $t('addTitle') }}</b-button>
          </template>


          <prices :prices="prices" :isServer="false"></prices>
          <!--END Front Prices-->
          <br>
          <br>

          <b-button
              @click="storePrices('default')"
              v-if="prices.length > 0" variant="success">{{ $t('saveTitle') }}
          </b-button>


          <br>
          <br>
          <br>
          <br>

          <h3>Saved Prises ({{ pricesFromServer.length }})</h3>
          <prices :prices="pricesFromServer" :isTab="myTrue" :isServer="myTrue"></prices>


        </b-tab>
        <!--END Price-->
        <b-tab @click="deletePriceItemValues" v-if="role === 'admin'" title="Prise Group">

          <b-row>
            <b-col cols="12">
              <h2 class="font-weight-bold">Add/Edit Group</h2>
            </b-col>

            <b-col cols="12" md="2">
              <b-form-group label="Group title">
                <b-input v-model="priceGroup.form.title" placeholder="title"></b-input>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="2">
              <b-form-group label="Offer amount">
                <b-input type="number" v-model="priceGroup.form.offer_amount" placeholder="amount"></b-input>
              </b-form-group>
            </b-col>

            <b-button
                @click="storePriceGroup"
                variant="success">{{ $t('save') }}
            </b-button>
          </b-row>

          <div class="my-5 border-bottom" v-if="priceGroup.items.length > 0">
            <h3 class="font-weight-bold">Groups ({{ priceGroup.items.length }})</h3>
            <b-list-group>
              <b-list-group-item
                  v-for="(item,index) in priceGroup.items"
                  :key="index"
                  :variant="form.price_group_id !== null && form.price_group_id == item.id ? 'success' : ''"
                  class="d-flex justify-content-between align-items-center pl-0">
                <div>
                  <span class="mx-3">{{ item.title }}</span>
                  <span class="mx-3 font-weight-bold">({{ item.offerAmount }}%)</span>
                  <span class="mx-3">single prices <span class="font-weight-bold">({{ item.pricesCountSingle }})</span></span>
                  <span class="mx-3 ">offer prices <span
                      class="font-weight-bold">({{ item.pricesCountOffer }})</span></span>
                </div>

                <div>
                  <b-badge class="mx-1 font-14" variant="primary" pill>
                    <a @click.prevent="getPriceGroup(item.id)" class="text-white" href="#">prices</a>
                  </b-badge>
                  <b-badge class="mx-1 font-14" variant="info" pill>
                    <a @click.prevent="editPriceGroupItem(item)" class="text-white" href="#">edit</a>
                  </b-badge>
                  <b-badge class="mx-1 font-14" variant="danger" pill>
                    <a @click.prevent="deletePriceGroup(item.id)" class="text-white" href="#">delete</a>
                  </b-badge>
                </div>

              </b-list-group-item>
            </b-list-group>
          </div>

          <!--END Group-->


          <template v-if="priceGroup.showPrices">
            <b-row>

              <b-col cols="12">
                <h2 class="font-weight-bold">Prices "{{ priceGroup.titleSelected }}"</h2>
              </b-col>


              <b-col cols="12" md="2">
                <b-form-group label="select prise type">
                  <b-form-select @input="onSelectPriceType">
                    <b-form-select-option value="gram">Gram</b-form-select-option>
                    <b-form-select-option value="gram_offer">Gram Discount</b-form-select-option>
                    <b-form-select-option value="single_price">Single Prise</b-form-select-option>
                    <b-form-select-option value="single_price_offer">Single Prise Discount
                    </b-form-select-option>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="4" v-if="isPriceGram">
                <b-form-group label="Titel">
                  <b-input v-model="priceItem.title"></b-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="3" v-if="isPriceGram">
                <b-form-group label="Abnehmen aus dem Lager">
                  <b-input v-model.number="priceItem.amountgram" type="number"></b-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="3"
                     v-if="isPriceOffer">
                <b-form-group label="Rabbat Percent">
                  <b-input v-model.number="priceItem.offerDiscount" type="number"></b-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="2">
                <b-form-group label="price">
                  <b-input v-model.number="priceItem.price" type="number"></b-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="2"
                     v-if="priceItem.priceType === 'single_price_offer' || priceItem.priceType === 'gram_offer'">
                <b-form-group label="price sell">
                  <b-input v-model.number="priceItem.priceSell" type="number"></b-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="3">
                <b-form-group label="Mit Rabatt anzeigen?">
                  <b-form-checkbox v-model="priceItem.priceGroup">Mit Rabatt anzeigen?</b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="3">
                <b-form-group label="is Hide?">
                  <b-form-checkbox v-model="priceItem.isHide">is Hide?</b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>

            <template v-if="editPriceItem !== null">
              <b-button variant="success" @click="updatePrice">{{ $t('saveTitle') }}</b-button>
              <b-button variant="danger" @click="deletePriceItemValues">{{ $t('cancelTitle') }}</b-button>
            </template>
            <template v-else>
              <b-button variant="info" @click="addPriceItem('group')">{{ $t('addTitle') }}</b-button>
            </template>


            <prices :prices="pricesGroup" :isServer="false"></prices>
            <!--END Front Prices-->
            <br>
            <br>

            <b-button
                @click="storePrices('group')"
                v-if="pricesGroup.length > 0" variant="success">{{ $t('saveTitle') }}
            </b-button>


            <br>
            <br>
            <br>
            <br>

            <h3>Saved Prises ({{ priceGroup.prices.length }})</h3>
            <prices :prices="priceGroup.prices" :isTab="myTrue" :isServer="myTrue"></prices>

          </template>

        </b-tab>
        <!--END Price Group-->
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import Navbar from "../Partials/Navbar";
import Http from '../../Services/HttpService/HttpService'
import Notification from '../../Services/Notification/Nottification'
import Validation from '../../Services/Validation/Validation'
import Package from "./Components/Package";
import {EventBus} from "../../Services/Eventbus/event-bus";
import Prices from "./Components/Prices";
import Packages from "./Components/Packages";

export default {
  name: "EditProduct",
  components: {Prices, Packages, Navbar},
  data() {
    return {
      isReceiveData: true,
      role: null,
      number: 1,
      myFalse: false,
      myTrue: true,
      packageStatus: null,
      validation: new Validation(),
      previewUrl: null,
      previewCoverUrl: null,
      categoryItem: {
        subCategories: []
      },
      imagesPreview: [],
      imagesFromServer: [],
      categories: [],
      form: {
        subCategory: null,
        price_group_id: null,
        category: null,
        title: null,
        meta_title: null,
        title_seo: null,
        price_label: '',
        inventory_count: null,
        cbd: null,
        cbg: null,
        thc: null,
        is_offer: "no",
        is_show_price_group: "no",
        is_biologisch: false,
        is_gram: true,
        is_new: false,
        is_single_price: false,
        is_custom_stock_count: false,
        is_hidden: false,
        is_hide_package_items: false,
        is_comingsoon: false,
        is_package: false,
        is_order_type: false,
        is_top_seller: false,
        is_custom_badge: false,
        is_advertising: false,
        custom_badge_title: null,
        custom_badge_text: null,
        offer_inp: 0,
        tax: null,
        select_package_count: 5,
        description: null,
        product_out_stock_message: null,
        brand: null,
        product_number: null,
        description_package: null,
        seocontent: null,
      },
      formImage: {
        image: null,
        image_cover: null,
        images: [],
      },
      priceItem: {
        amountgram: 1,
        title: null,
        price: null,
        priceSell: null,
        priceType: 'gram',
        priceGroup: false,
        isHide: false,
        offerDiscount: 0,
      },
      prices: [],
      pricesGroup: [],
      pricesFromServer: [],
      packages: [],
      packagesSavedProductServer: [],
      products: [],
      packageItem: {
        id: 0,
        title: null,
        product_id: null,
        parent_product_id: null,
        isHide: false,
        isCustomTitle: false,
        count: 1,
      },
      editPriceItem: null,
      editPackageItem: null,
      optionsEditor: {
        height: 300,
        toolbar: [
          'formatselect | fontsizeselect | fontselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent | removeformat | bootstrap4grid'
        ]
      },
      packagesCustomTitle: [],
      packagesCategory: [],
      priceGroup: {
        showPrices: false,
        isEdit: false,
        id: null,
        titleSelected: null,
        form: {
          title: null,
          offer_amount: 0,
        },
        items: [],
        prices: [],
      },
    }
  },
  computed: {
    isPriceGram() {
      return this.priceItem.priceType === 'gram' || this.priceItem.priceType === 'gram_offer';
    },
    isPriceOffer() {
      return this.priceItem.priceType === 'single_price_offer' || this.priceItem.priceType === 'gram_offer';
    }
  },

  methods: {
    getPriceGroup(id) {
      this.priceGroup.showPrices = false;
      Http.get(Http.apiurlV2() + 'product/priceGroup/show/' + id)
          .then(response => {
            this.$Progress.finish();
            if (response.data.status_code === Http.ok()) {
              this.priceGroup.showPrices = true;
              this.priceGroup.id = id;
              this.priceGroup.prices = response.data.data.prices;
              this.priceGroup.titleSelected = response.data.data.title;
            } else {
              Notification.error(response.data.message);

            }
          })
          .catch(error => {
            this.$Progress.finish();
          })
    },
    deletePriceGroup(id) {
      if (confirm(this.$t('alertText'))) {
        this.$Progress.start();
        Http.get(Http.apiurlV2() + 'product/priceGroup/delete/' + id)
            .then(response => {
              this.$Progress.finish();
              if (response.data.status_code === Http.ok()) {
                this.getDetailsProduct();
                if (id === this.priceGroup.id) {
                  this.priceGroup.showPrices = false;
                  this.priceGroup.prices = [];
                  this.priceGroup.titleSelected = null;
                }

                Notification.success(response.data.message);
              } else {
                Notification.error(response.data.message);

              }
            })
            .catch(error => {
              this.$Progress.finish();
            })
      }

    },
    editPriceGroupItem(myItem) {
      this.priceGroup.isEdit = true;
      this.priceGroup.id = myItem.id;
      this.priceGroup.form.title = myItem.title;
      this.priceGroup.form.offer_amount = myItem.offerAmount;
    },
    storePriceGroup() {

      //check if form group title not null
      if (this.priceGroup.form.title === null) {
        Notification.error("Please enter price group title");
        return;
      }
      if (this.priceGroup.form.offer_amount === 0) {
        Notification.error("Please enter offer amount");
        return;
      }

      var url;
      if (this.priceGroup.isEdit) {
        url = "product/priceGroup/update/" + this.priceGroup.id;
      } else {
        url = "product/priceGroup/store/" + this.$route.params.productid;
      }

      this.$Progress.start();
      Http.post(Http.apiurlV2() + url, this.priceGroup.form)
          .then(response => {
            if (response.data.status_code === Http.ok()) {
              if (this.priceGroup.isEdit) {
                this.priceGroup.isEdit = false;
                if (this.priceGroup.showPrices) {
                  this.priceGroup.titleSelected = this.priceGroup.form.title;
                } else {
                  this.priceGroup.id = null;
                }
              }
              this.$Progress.finish();
              this.priceGroup.form.title = null;
              this.priceGroup.form.offer_amount = 0;
              Notification.success(response.data.message);
              this.getDetailsProduct();
            } else {
              Notification.error(response.data.message)
            }
          })
          .catch(error => {
            this.$Progress.finish();
          })
    },
    removePackageFilter() {
      this.packageStatus = null;
      this.form.is_package = false;
      this.form.is_hide_package_items = false;
    },
    onSelectFile(event) {
      this.previewUrl = URL.createObjectURL(event.target.files[0]);
    },
    onSelectFileCover(event) {
      this.previewCoverUrl = URL.createObjectURL(event.target.files[0]);
    },
    onSelectFiles(e) {
      this.formImage.images = [];
      this.imagesPreview = [];

      var files = e.target.files || e.dataTransfer.files;
      if (!files.length)
        return;
      for (var i = files.length - 1; i >= 0; i--) {
        this.formImage.images.push(files[i]);
        this.imagesPreview.push({
          id: i,
          url: URL.createObjectURL(files[i])
        });
      }
      document.getElementById("images").value = [];

    },
    removeImage(image) {
      let imageItem = this.imagesPreview.find(item => item.id === image.id);
      if (imageItem) {
        this.formImage.images.splice(this.formImage.images.indexOf(image), 1);
        this.imagesPreview.splice(this.imagesPreview.indexOf(image), 1);
      } else {
        alert('Image Not Found')
      }

    },
    updateImage() {
      let fd = new FormData();
      if (this.formImage.image !== null) {
        fd.append('image', this.formImage.image);
      }
      if (this.formImage.image_cover !== null) {
        fd.append('image_cover', this.formImage.image_cover);
      }

      Http.post(Http.apiurlV2() + 'product/update/image/' + this.$route.params.productid, fd, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
      })
          .then(response => {
            this.$Progress.finish();
            if (response.data.status_code === Http.ok()) {
              Notification.success(response.data.message);
              this.getDetailsProduct();
            } else {
              this.validation.store(response.data.data);
              Notification.error(response.data.message)

            }
          })
          .catch(error => {
            this.$Progress.finish();
          })

    },
    updateGalleryImage() {
      let fd = new FormData();
      if (this.formImage.images.length) {
        this.formImage.images.map(photo => fd.append('images[]', photo, photo.name));
      }

      Http.post(Http.apiurlV2() + 'product/slider/store/' + this.$route.params.productid, fd, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
      })
          .then(response => {
            this.$Progress.finish();
            if (response.data.status_code === Http.created()) {
              Notification.success(response.data.message);
              this.imagesPreview = [];
              this.getDetailsProduct();
            } else {
              this.validation.store(response.data.data);
              Notification.error(response.data.message)

            }
          })
          .catch(error => {
            this.$Progress.finish();
          })

    },
    updateInformation() {
      Http.post(Http.apiurlV2() + 'product/update/' + this.$route.params.productid, this.form)
          .then(response => {
            this.$Progress.finish();
            if (response.data.status_code === Http.ok()) {
              Notification.success(response.data.message);
              this.getDetailsProduct();
            } else {
              this.validation.store(response.data.data);
              Notification.error(response.data.message)

            }
          })
          .catch(error => {
            this.$Progress.finish();
          })

    },
    deleteImage(id) {
      this.$Progress.start();
      Http.get(Http.apiurlV2() + 'product/slider/delete/' + id)
          .then(response => {
            this.$Progress.finish();
            if (response.data.status_code === Http.ok()) {
              this.getDetailsProduct();
              Notification.success(response.data.message);
            } else {
              Notification.error(response.data.message);

            }
          })
          .catch(error => {
            this.$Progress.finish();
          })
    },
    onChangePackageType(myType) {
      switch (myType) {
        case 'package':
          this.form.is_hide_package_items = false;
          this.form.is_package = true;
          this.packages = [];
          break;
        case 'packageItems':
          this.form.is_package = false;
          this.form.is_hide_package_items = true;
          this.packages = [];
          break;
      }
    },
    deletePriceItemValues() {
      this.priceType = null;
      this.editPriceItem = null;
      this.priceItem.amountgram = 0;
      this.priceItem.offerDiscount = 0;
      this.priceItem.stockCount = 0;
      this.priceItem.title = null;
      this.priceItem.price = null;
      this.priceItem.priceSell = null;
      this.priceItem.priceGroup = false;
      this.priceItem.isHide = false;
    },
    deletePackageItemValues() {
      this.editPackageItem = null;
      this.packageItem.id = 0;
      this.packageItem.title = null;
      this.packageItem.count = 1;
      this.packageItem.product_id = null;
      this.packageItem.parent_product_id = null;
      this.packageItem.isHide = false;
      this.packageItem.isCustomTitle = false;
    },
    onSelectPriceType(myValue) {
      this.priceItem.priceType = myValue;
      this.deletePriceItemValues();
      switch (myValue) {
        case "gram":
          this.form.is_gram = true;
          this.form.is_single_price = false;
          break;
        case "gram_offer":
          this.form.is_gram = true;
          this.form.is_single_price = false;
          // this.priceItem.priceGroup = true;
          break;
        case "single_price":
          this.form.is_gram = false;
          this.form.is_single_price = true;
          break;
        case "single_price_offer":
          this.form.is_gram = false;
          this.form.is_single_price = true;
          // this.priceItem.priceGroup = true;
          break;
      }
    },
    addPriceItem(type) {
      //check if price for group
      if (type === "group") {
        this.pricesGroup.push({
          id: this.number++,
          groupId: this.priceGroup.id,
          title: this.priceItem.title,
          price: this.priceItem.price,
          priceSell: this.priceItem.priceSell,
          type: this.priceItem.priceType,
          gram: this.priceItem.amountgram,
          offerDiscount: this.priceItem.offerDiscount,
          priceGroup: this.priceItem.priceGroup,
          isHide: this.priceItem.isHide,
        });
      } else {
        this.prices.push({
          id: this.number++,
          groupId: null,
          title: this.priceItem.title,
          price: this.priceItem.price,
          priceSell: this.priceItem.priceSell,
          type: this.priceItem.priceType,
          gram: this.priceItem.amountgram,
          offerDiscount: this.priceItem.offerDiscount,
          priceGroup: this.priceItem.priceGroup,
          isHide: this.priceItem.isHide,
        });
      }

      this.deletePriceItemValues();
    },
    onSelectOfferType() {
      if (this.form.is_offer === 'init' || this.form.is_offer === 'no') {
        this.form.offer_inp = 0;
      }
    },
    addPackageItem() {
      this.packages.push({
        id: this.number++,
        is_hide: this.packageItem.isHide,
        is_custom_title: this.packageItem.isCustomTitle,
        is_show_product: this.form.is_hide_package_items,
        product_id: this.packageItem.product_id,
        title: this.packageItem.title,
        count: this.packageItem.count,
      });

      this.deletePackageItemValues();
    },
    storePackage() {
      if (this.packageItem.title === null) {
        Notification.error("package title is required")
      } else {
        this.$Progress.start();
        Http.post(Http.apiurlV2() + 'product/package/store/' + this.form.category, {
          'is_hide': this.packageItem.isHide,
          'is_custom_title': this.packageItem.isCustomTitle,
          'is_show_product': false,
          'parent_product_id': (this.packageItem.isCustomTitle ? this.$route.params.productid : null),
          'product_id': this.packageItem.product_id,
          'count': this.packageItem.count,
          'title': this.packageItem.title
        })
            .then(response => {
              if (response.data.status_code === Http.created()) {
                this.$Progress.finish();
                this.getPackageItems();
                this.deletePackageItemValues();
                Notification.success(response.data.message)
              }
            })
            .catch(error => {
              this.$Progress.finish();
            })
      }

    },
    updatePackage() {
      this.$Progress.start();
      Http.post(Http.apiurlV2() + 'product/packages/update/items', {
        productId: this.$route.params.productid,
        packages: this.packages,
      })
          .then(response => {
            if (response.data.status_code === Http.created()) {
              this.$Progress.finish();
              this.getDetailsProduct();
              this.deletePackageItemValues();
              this.packages = [];
              Notification.success(response.data.message)
            }
          })
          .catch(error => {
            this.$Progress.finish();
          })

    },
    getPackageItems() {
      this.$Progress.start();
      let url;
      url = Http.apiurlV2() + 'product/package/index/' + this.form.category + '/' + this.$route.params.productid;

      Http.get(url)
          .then(response => {
            this.$Progress.finish();
            if (response.data.status_code === Http.ok()) {
              this.packages = [];
              this.packagesCustomTitle = [];
              this.packagesCategory = [];
              this.packagesCategory = response.data.data.packages;
              this.packagesCustomTitle = response.data.data.packagesCustomTitle;

              /*this.packages.filter(item => {
                  if (item.isCustomTitle.match('yes') || item.isCustomTitle.match(true)) {
                      this.packagesCustomTitle.push(item);
                  }
                  if (item.isCustomTitle.match('no')) {
                      this.packagesCategory.push(item);
                  }
              })*/

            }
          })
          .catch(error => {
            this.$Progress.finish();
          })
    },
    getPackageProductItems() {
      this.$Progress.start();
      Http.get(Http.apiurlV2() + 'product/package/get/products')
          .then(response => {
            this.$Progress.finish();
            if (response.data.status_code === Http.ok()) {
              this.products = response.data.data;
            }
          })
          .catch(error => {
            this.$Progress.finish();
          })
    },
    getDetailsProduct() {
      if (this.$route.params.productid && this.$route.params.productid > 0) {
        this.$Progress.start();
        this.isReceiveData = false;
        Http.get(Http.apiurlV2() + 'product/show/' + this.$route.params.productid)
            .then(response => {
              this.$Progress.finish();
              if (response.data.status_code === Http.ok()) {
                this.isReceiveData = true;
                this.categories = response.data.data.categories;
                let product = response.data.data.product;
                this.categoryItem.subCategories = response.data.data.subCategories;
                this.form.category = product.product_category_id;
                this.form.price_group_id = product.price_group_id;
                this.form.subCategory = product.product_subcategory_id;
                this.form.title = product.product_title;
                this.form.meta_title = product.product_meta_title;
                this.form.title_seo = product.product_title_url;
                this.form.price_label = product.product_price;
                this.form.inventory_count = product.product_count;
                this.form.cbd = product.product_cbd;
                this.form.cbg = product.product_cbg;
                this.form.thc = product.product_thc;
                this.form.is_offer = product.product_is_offer;
                this.form.is_show_price_group = product.product_is_show_price_group;
                this.form.offer_inp = product.product_offer_amount;
                this.form.tax = product.product_tax_amount;
                this.form.select_package_count = product.product_select_package_count;
                this.form.description = product.product_desc;
                this.form.product_out_stock_message = product.product_out_stock_message;
                this.form.brand = product.product_brand;
                this.form.product_number = "LOF" + product.product_id;
                this.form.description_package = product.product_desc_package;
                this.form.seocontent = product.product_seo_content;
                this.form.is_order_type = product.product_is_order_type;
                this.previewCoverUrl = product.product_image_url;
                this.previewUrl = product.product_image_thumb_url;
                this.form.is_single_price = product.product_is_single_price === 'yes';
                this.form.is_top_seller = product.product_is_top_seller === 'yes';
                this.form.is_comingsoon = product.product_is_comingsoon === 'yes';
                this.form.is_hidden = product.product_is_hidden === 'yes';
                this.form.is_biologisch = product.product_is_biologisch === 'yes';
                this.form.is_advertising = product.product_is_advertising === 'yes';
                this.form.is_package = product.product_is_package === 'yes';
                this.form.is_gram = product.product_is_gram_amount === 'yes';
                this.form.is_custom_stock_count = product.product_is_custom_stock === 'yes';
                this.form.is_hide_package_items = product.product_hide_package_items === 'yes';
                this.form.is_new = product.product_is_new === 'yes';
                this.form.is_custom_badge = product.product_is_custom_badge === 'yes';
                this.form.custom_badge_title = product.product_custom_badge_title;
                this.form.custom_badge_text = product.product_custom_badge_text;
                this.imagesFromServer = response.data.data.images;
                this.packagesSavedProductServer = response.data.data.packages;
                this.pricesFromServer = response.data.data.prices;
                this.priceGroup.items = response.data.data.priceGroups;


                if (this.form.is_package && this.form.is_hide_package_items) {
                  this.packageStatus = 'packageAndHide';
                } else if (this.form.is_package) {
                  this.getPackageItems();
                  this.packageStatus = 'package';
                }


              } else {
                Notification.error(response.data.message)
              }
            })
            .catch(error => {
              this.$Progress.finish();
            })
      }
    },
    storePrices(type) {

      var pricesSend;
      if (type === "group") {
        pricesSend = this.pricesGroup;
      } else {
        pricesSend = this.prices;
      }

      this.$Progress.start();
      Http.post(Http.apiurlV2() + 'product/price/store/' + this.$route.params.productid, {
        prices: pricesSend
      })
          .then(response => {
            this.$Progress.finish();
            if (response.data.status_code === Http.created()) {
              this.getDetailsProduct();

              if (type === "group") {
                this.pricesGroup = [];
                this.getPriceGroup(this.priceGroup.id);
              } else {
                this.prices = [];
              }
            }
          })
          .catch(error => {
            this.$Progress.finish();
          })
    },
    editPriceItemProcess(myItem) {
      window.scrollTo(0, 0);
      this.editPriceItem = myItem;
      this.priceItem.priceGroup = (this.editPriceItem.priceGroup === 'offer');
      this.priceItem.isHide = (this.editPriceItem.isHide === 'yes');
      this.priceItem.priceSell = this.editPriceItem.priceSell;
      this.priceItem.price = this.editPriceItem.price;
      this.priceItem.offerDiscount = this.editPriceItem.offerDiscount;
      this.priceItem.title = this.editPriceItem.title;
      this.priceItem.amountgram = this.editPriceItem.gram;
      this.priceItem.priceType = this.editPriceItem.type;
    },
    editPackageItemProcess(myItem) {
      window.scrollTo(0, 0);
      this.editPackageItem = myItem;
      this.packageItem.isHide = (this.editPackageItem.formatShow === 'hide');
      this.packageItem.isCustomTitle = (this.editPackageItem.isCustomTitle === 'yes');
      this.packageItem.title = this.editPackageItem.title;
      this.packageItem.product_id = this.editPackageItem.product_id;
      this.packageItem.count = this.editPackageItem.count;
      this.packageItem.id = this.editPackageItem.id;
    },
    updatePrice() {
      this.$Progress.start();
      Http.post(Http.apiurlV2() + 'product/price/update/' + this.editPriceItem.id, this.priceItem)
          .then(response => {
            this.$Progress.finish();
            if (response.data.status_code === Http.ok()) {
              this.getDetailsProduct();
              this.editPriceItem = null;
              this.deletePriceItemValues();
              this.priceItem.priceType = 'gram';
              Notification.success(response.data.message)

              if (this.priceGroup.showPrices) {
                this.getPriceGroup(this.priceGroup.id);
              }
            } else {
              Notification.error(response.data.message)

            }
          })
          .catch(error => {
            this.$Progress.finish();
          })
    },
    updatePackageItemProcess() {
      this.$Progress.start();
      if (this.packageItem.isCustomTitle) {
        this.packageItem.parent_product_id = this.$route.params.productid;
      }
      Http.post(Http.apiurlV2() + 'product/package/update/' + this.editPackageItem.id, this.packageItem)
          .then(response => {
            this.$Progress.finish();
            if (response.data.status_code === Http.ok()) {
              this.getDetailsProduct();
              this.editPackageItem = null;
              this.deletePackageItemValues();
              Notification.success(response.data.message)

            } else {
              Notification.error(response.data.message)

            }
          })
          .catch(error => {
            this.$Progress.finish();
          })
    },
  },
  created() {
    this.getDetailsProduct();
    this.getPackageProductItems();
    this.role = localStorage.getItem('role');
  },
  mounted() {
    let myThis = this;

    EventBus.$on('updatePackage', function (payload) {
      if (payload === 'yes') {
        if (myThis.form.is_hide_package_items) {
          myThis.getDetailsProduct();
        } else {
          myThis.getPackageItems()
        }
      }
    });

    EventBus.$on('updatePriceItem', function (payload) {
      if (payload !== null) {
        myThis.editPriceItemProcess(payload);
      }
    });

    EventBus.$on('updatePackageItem', function (payload) {
      if (payload !== null) {
        myThis.editPackageItemProcess(payload);
      }
    });

    EventBus.$on('refreshProduct', function (payload) {
      if (payload === 'yes') {
        myThis.getDetailsProduct()
      }
    });


  }
}
</script>

<style scoped>

</style>